import RedebitListModelBase from '../_generated/modelBases/redebit-list-model-base';

export default class RedebitListModel extends RedebitListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
